"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRouterDom = require("react-router-dom");

var _NavHamburger = _interopRequireDefault(require("./NavHamburger"));

var _NavigationLogo = _interopRequireDefault(require("./NavigationLogo"));

var _bestApps = _interopRequireDefault(require("../../assets/logo/best-apps.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NavBarStyled = _styledComponents["default"].nav.attrs(function (_ref) {
  var expandStyle = _ref.expandStyle;
  return {
    className: "navbar fixed-top navbar-expand-".concat(expandStyle, " navbar-light bg-faded justify-content-start"),
    id: "best-navbar"
  };
}).withConfig({
  displayName: "Navigation__NavBarStyled",
  componentId: "kpsy6x-0"
})(["&&&{margin-top:", ";padding-top:4.5px;padding-bottom:4.5px;background:#041e42 url(", ") no-repeat right -4px top -1px;background-size:", ";box-shadow:0 4px 6px rgba(0,0,0,0.2);border-top:1px solid #041e42;border-bottom:1px solid #041e42;@media (max-width:768px){margin-top:", ";}z-index:1050;}"], function (props) {
  return props.loggedIn ? "22px" : "0";
}, _bestApps["default"], function (props) {
  return props.loggedIn ? "113px 59px" : "58px 30px";
}, function (props) {
  return props.paddMobile ? "1.125rem;" : "0px;";
});

var NavLogoHolderSignedOut = _styledComponents["default"].div.withConfig({
  displayName: "Navigation__NavLogoHolderSignedOut",
  componentId: "kpsy6x-1"
})(["height:0.625rem;"]);

var Navigation = function Navigation(_ref2) {
  var children = _ref2.children,
      loggedIn = _ref2.loggedIn,
      isLoginTab = _ref2.isLoginTab,
      logo = _ref2.logo,
      logoText = _ref2.logoText,
      mobileNavOpen = _ref2.mobileNavOpen,
      toggleMobileNav = _ref2.toggleMobileNav,
      builds = _ref2.builds,
      tabletSupport = _ref2.tabletSupport,
      displayEnvIndicator = _ref2.displayEnvIndicator;
  return _react["default"].createElement(NavBarStyled, {
    expandStyle: tabletSupport ? "lg" : "md",
    loggedIn: loggedIn,
    envIndicator: !loggedIn,
    paddMobile: loggedIn && !displayEnvIndicator
  }, loggedIn ? _react["default"].createElement(_NavHamburger["default"], {
    open: mobileNavOpen,
    toggle: toggleMobileNav
  }) : null, _react["default"].createElement(_reactRouterDom.Link, {
    className: "navbar-brand",
    to: "/"
  }, loggedIn ? logo ? _react["default"].createElement(_NavigationLogo["default"], {
    logo: logo,
    logoText: logoText,
    builds: builds
  }) : _react["default"].createElement(_NavigationLogo["default"], {
    logo: _bestApps["default"],
    logoText: logoText,
    builds: builds
  }) : _react["default"].createElement(NavLogoHolderSignedOut, null)), loggedIn ? children : null);
};

Navigation.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  loggedIn: _propTypes["default"].bool.isRequired,
  isLoginTab: _propTypes["default"].bool,
  logo: _propTypes["default"].any,
  logoText: _propTypes["default"].string,
  tabletSupport: _propTypes["default"].bool,
  mobileNavOpen: _propTypes["default"].bool.isRequired,
  displayEnvIndicator: _propTypes["default"].bool.isRequired,
  toggleMobileNav: _propTypes["default"].func.isRequired,
  builds: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    build: _propTypes["default"].string.isRequired
  }))
};
Navigation.defaultProps = {
  displayName: "navigation",
  isProd: false,
  isLoginTab: false,
  builds: [],
  tabletSupport: false,
  logo: null,
  logoText: null
};
var _default = Navigation;
exports["default"] = _default;